import React, { Component } from 'react'
import Axios from 'axios'
import moment from 'moment';
import { Link } from 'react-router-dom';



class AnaliseDuplicidade extends Component {

    constructor(props) {
        super(props)
        this.state = {
            pedidos : [],
            cartelas: [],
            cartelasPedidos: [],
            count: 0
        }
        this.getTodosPedidos()

    }


    async getTodosPedidos(){
        try {
            var axiosInstance = new Axios.create({
              baseURL: window.localStorage.getItem("apiUrl")
            });
            const response = await axiosInstance.get("pedidos/listar-2", {});
            this.setState({pedidos: response.data});
            if(response.data)
                this.getTodasCartelas()
          } catch (err) {
            console.log(err);
          }
    }
    async getTodasCartelas(){
        var cartelasPedidos = []
        this.state.pedidos.map(pedido =>{
          var gerente = {};
            pedido.cartelas.map(cartela => {
                cartelasPedidos.push({cartela,pedido, gerente})
            })
        })
        this.setState({cartelasPedidos : cartelasPedidos.sort(this.compararPedidos)})
        this.state.cartelasPedidos.map(cartelasPedido => {
            if(cartelasPedido.pedido.cambistaId &&  cartelasPedido.pedido.cambistaId.tutorId != undefined)
            this.getTutor(cartelasPedido)
        })
       
    }

    compararPedidos (a, b) {
        if (a.cartela.codigo > b.cartela.codigo) {
          return 1;
        }
        if (a.cartela.codigo < b.cartela.codigo) {
          return -1;
        }

        return 0
    }

    comparaAdjadcentes(e){
      var index = e;
      var lastIndex = index -1;
      var nextIndex = index + 1;
      var item = this.state.cartelasPedidos[index];
     if( this.state.cartelasPedidos[lastIndex] && this.state.cartelasPedidos[nextIndex] &&
         (this.state.cartelasPedidos[index-1].cartela.codigo == item.cartela.codigo || 
          this.state.cartelasPedidos[index+1].cartela.codigo == item.cartela.codigo) ){
          this.state.count++;
          return true;
          }
     else{
         return false;
     }
  }


  async getTutor(item){
      try {
        var axiosInstance = new Axios.create({
            baseURL: window.localStorage.getItem("apiUrl")
        });
        const response = await axiosInstance.post("usuarios/user", {id: item.pedido.cambistaId.tutorId})
        if(response.data){
          item.gerente = response.data[0];
          console.log(item.gerente)
          this.setState({cartelasPedidos: this.state.cartelasPedidos})
        }
    } catch (err) {
        console.log(err);
    }
  }


  alteraPedido(e){
    var pedido = JSON.parse(e.target.accessKey).pedido;
    var cartela = JSON.parse(e.target.accessKey).cartela;
    pedido.cartelas.map(pCartela => {
      if(pCartela.codigo == cartela.codigo){
        pCartela.codigo = pCartela.codigo.substring(0,5) + "-0"
        pCartela.numeros[7] = 0;
        this.updatePedido(pedido)
      }
    })
  }

  async updatePedido(pedido){
    try {
      var axiosInstance = new Axios.create({
          baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.post("pedidos/modifica-cartela", {id: pedido._id, cartelas : pedido.cartelas})
      this.forceUpdate()
  } catch (err) {
      console.log(err);
  }
  }


  countFInit(){
      this.state.count = 0;
  }
  countFMore(){
    this.state.count = this.state.count + 1 ;
}
    render() {
        return (

            <div className="container" >
              {this.countFInit()}
                <table class="table">
                <thead class="thead-dark">
                    <tr>
                    <th scope="col">no.</th>
                    <th scope="col">Pedido</th>
                    <th scope="col">Status</th>
                    <th scope="col">Cartela</th>
                    <th scope="col">Cliente</th>
                    <th scope="col">Vendedor</th>
                    <th scope="col">Gerente</th>
                    </tr>
                </thead>
                <tbody>
               
                {this.state.cartelasPedidos.map((item,index) => {

                  if(this.comparaAdjadcentes(index)){
                    this.countFMore()
                   return <tr >
                     <th scope="row">{this.state.count/2}</th>
                    <th scope="row">{item.pedido.codigo}</th>
                    <td>{item.pedido.recebido? 'Recebido' : 'Não Recebido'}</td>
                    <td>{item.cartela.codigo}</td>
                    <td>{item.pedido.clienteId? item.pedido.clienteId.nome : ""}</td>
                    <td>{item.pedido.cambistaId? item.pedido.cambistaId.nome : ""}</td>
                    <td>{item.gerente? item.gerente.nome : ""}</td>
                    <td><button accessKey={JSON.stringify(item)} onClick={this.alteraPedido.bind(this)}>ALTERAR</button></td>
                    
                    </tr>
                  }
                })}

                </tbody>
                </table>


            </div>
        )
    }


}

export default AnaliseDuplicidade